var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g(_vm._b({attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill":_vm.fill},domProps:{"innerHTML":_vm._s(_vm.Icon)}},'svg',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }